import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Divider } from '@/components/UI/Divider/Divider.styles';
import { getMaskIconStyles } from '@/styles/helpers';

export const FooterBox = styled.footer<{
  $bottomGutter: string;
  $hasBorder: boolean;
  $isBusinessPage?: boolean;
}>`
  width: 100%;
  padding: 25px 15px
    ${({ theme, $bottomGutter }) =>
      theme.isWebView ? `calc(25px + ${$bottomGutter})` : $bottomGutter};
  background-color: ${({ theme }) =>
    theme.isWebView ? 'transparent' : theme.palette.primary.background};

  ${({ $hasBorder }) =>
    $hasBorder &&
    css`
      border-top: 1px solid ${({ theme }) => theme.palette.secondary.border};
    `}

  ${({ $isBusinessPage }) =>
    $isBusinessPage &&
    css`
      margin: 0;
      padding: 25px 40px;
    `}
`;

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  > a {
    max-width: max-content;
  }
`;

export const FooterSocials = styled.div`
  display: flex;
  gap: 25px;
  margin: 25px 0;
`;

export const FooterSocial = styled.a<{ $iconName: string }>`
  display: block;
  background-image: ${({ $iconName }) => `url('/images/${$iconName}.svg')`};
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const FooterSiteVersions = styled.div`
  display: flex;
  align-items: baseline;
  gap: 15px;
`;

export const FooterPhones = styled.div`
  margin-bottom: 10px;
`;

export const FooterResponsibility = styled(Typography.Caption)`
  max-width: 85%;
  margin: 15px 0;
`;

export const FooterDivider = styled(Divider)`
  margin: 20px 0;
  background-color: ${({ theme }) => theme.palette.secondary.border};
`;

export const PhoneNumber = styled(Typography.Numbers)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const MailAddress = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const FooterChangeLang = styled.div`
  position: relative;
  display: flex;
  gap: 10px;

  &::before {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.palette.secondary.labels};

    ${getMaskIconStyles('language.svg')};
  }
`;
